import { SearchEntity } from "PFApp/components/search_autocomplete/search_autocomplete.types";
import { SearchInput } from "PFApp/components/search_input";
import { RecentSearchesPageKey } from "PFTypes/recent_searches";
import React, { useState } from "react";

import { AllResourcesTable } from "./all_resources_table";
import { RowSelection } from "./reassign_content";
import css from "./reassign_content.module.scss";

export const ReassignContentAllResources = ({ onTargetProfileChange, rowSelectionState }: RowSelection) => {
  const [allResourcesSearchValue, setAllResourcesSearchValue] = useState("");

  return (
    <>
      <SearchInput
        term={allResourcesSearchValue}
        pageKey={RecentSearchesPageKey.ReassignProfile}
        onTermChange={(value: string) => setAllResourcesSearchValue(value)}
        classes={{
          root: css.search
        }}
        autocompleteConfig={[{ entity: SearchEntity.Profile, useAsTerm: true, profileVisibility: "active" }]}
        fullWidth
      />
      <AllResourcesTable
        searchValue={allResourcesSearchValue}
        onTargetProfileChange={onTargetProfileChange}
        rowSelectionState={rowSelectionState}
      />
    </>
  );
};
